import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../../../Context/AuthContext';

const Organization = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { decodeS1 } = useAuth();
  const s1 = decodeS1();

  const [select, setSelect] = useState(0); // 상단 드롭다운용
  const [category, setCategory] = useState('management'); // 직원정보 카테고리
  const [tab, setTab] = useState('management'); // 탭 활성 상태
  const [boardData, setBoardData] = useState([]); // 직원 리스트

  const pageSize = 9999; // 한 페이지에 전부 뿌릴 용도(충분히 크게)

  // 페이지 이동 공통
  const handleSelect = (num) => {
    if (select === num) {
      setSelect(0);
    } else {
      setSelect(num);
    }
  };

  const moveBoard = (cate) => {
    navigate(`/board/${cate}`, { state: { cate: cate } });
  };

  const movePage = (path) => {
    navigate(path);
  };

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  // ───────────────── 직원정보 관련 로직 ─────────────────

  // 카테고리별 직원 리스트 조회 (페이지네이션 제거, 전부 조회)
  const categoryDataSet = (category) => {
    axios
      .get(`https://ciuc.or.kr:8443/api/get/organization_list?category=${category}&page=1&pageSize=${pageSize}`)
      .then((response) => {
        setBoardData(response.data.data);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  // 직원 업무 줄바꿈 + 불릿 렌더링 (DB는 , 기준)
  const renderWorkLines = (work) => {
    if (!work) return null;

    const lines = work
      .split(',') // 🔥 DB 그대로 , 기준으로만 분리
      .map((line) => line.trim())
      .filter((line) => line);

    return lines.map((line, idx) => (
      <div className="org-work-line" key={idx}>
        <span className="org-work-bullet">●</span>
        <span className="org-work-text">{line}</span>
      </div>
    ));
  };

  // category 변경 시 데이터 조회
  useEffect(() => {
    categoryDataSet(category);
  }, [category]);

  // 직원정보 등록 페이지 이동
  const infoWrite = () => {
    navigate(`/organization/${category}/write`);
  };

  // 직원정보 탭 클릭
  const handleTab = (cat) => {
    setTab(cat);
    setCategory(cat);
  };

  const getCategoryName = (category) => {
    switch (category) {
      case 'management':
        return '경영기획실';
      case 'enterprise':
        return '기업지원실';
      case 'founded':
        return '창업육성실';
      default:
        return '';
    }
  };

  // ───────────────── JSX ─────────────────

  return (
    <div className="sub_wrap">
      <div className="sub_back">
        <div className="sub_banner_area intro-field">
          <div className="sub_banner_back">
            <div className="navi_text">
              <div className="home_icon_sub"></div>
              {'> '}융합원 소개{' > '}조직도
            </div>
            <div className="banner_main_text">조직도</div>
          </div>
        </div>

        <div className="navi_area">
          <div className="navi_back">
            <div className="navi_box" onClick={() => handleSelect(1)}>
              <div className="navi_main_text">융합원소개</div>
              <div className="navi_arrow"></div>
              <div className={`navi_select_box ${select === 1 && 'active'}`}>
                <div className="select_row" onClick={() => moveBoard('notice')}>
                  알림 및 소식
                </div>
                <div className="select_row" onClick={() => movePage('/fusionSupportProgram')}>
                  사업분야
                </div>
                <div className="select_row" onClick={() => movePage('/inquiryinfo')}>
                  기업연구동
                </div>
                <div className="select_row" onClick={() => movePage('/meetingroom')}>
                  보유시설
                </div>
                <div className="select_row" onClick={() => movePage('/vision')}>
                  융합원소개
                </div>
              </div>
            </div>

            <div className="navi_box" onClick={() => handleSelect(2)}>
              <div className="navi_main_text">조직도</div>
              <div className="navi_arrow"></div>
              <div className={`navi_select_box ${select === 2 && 'active'}`}>
                <div className="select_row" onClick={() => movePage('/intro')}>
                  인사말
                </div>
                <div className="select_row" onClick={() => movePage('/vision')}>
                  비전 및 목표
                </div>
                <div className="select_row" onClick={() => movePage('/history')}>
                  연혁
                </div>
                <div className="select_row" onClick={() => movePage('/organization')}>
                  조직도
                </div>
                <div className="select_row" onClick={() => movePage('/introduce')}>
                  소개자료
                </div>
                <div className="select_row" onClick={() => movePage('/regulations')}>
                  관리규정
                </div>
                <div className="select_row" onClick={() => movePage('/map')}>
                  오시는 길
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="sub_main_area founded">
          <aside className="intro_aside_fixed">
            <div className="intro_aside_header">
              <div className="center_box">
                <span>융합원소개</span>
                <div className="center_line"></div>
              </div>
            </div>
            <ul className="intro_aside_list">
              <li className={`intro_aside_item ${isActive('/intro')}`} onClick={() => movePage('/intro')}>
                <span>인사말</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/vision')}`} onClick={() => movePage('/vision')}>
                <span>비전 및 목표</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/history')}`} onClick={() => movePage('/history')}>
                <span>연혁</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/organization')}`} onClick={() => movePage('/organization')}>
                <span>조직도</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/introduce')}`} onClick={() => movePage('/introduce')}>
                <span>소개자료</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/regulations')}`} onClick={() => movePage('/regulations')}>
                <span>관리규정</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/map')}`} onClick={() => movePage('/map')}>
                <span>오시는 길</span>
                <span className="aside_arrow">&gt;</span>
              </li>
            </ul>
          </aside>

          <div className="sub_main_back organization">
            <div className="vision_container">
              <div className="vision_title_box">
                <div className="logo_box">
                  <div className="logo_img"></div>
                </div>
                <div className="title_text">조직도</div>
              </div>

              {/* ───────── 조직도 영역 (block + flex 버전) ───────── */}
              <div className="founded_img_box formation_one">
                <div className="organization_img formation_one">
                  <div className="org-chart">
                    {/* 중앙 세로 기준선 */}
                    <div className="org-center-line" />

                    {/* TOP – 이사장 */}
                    <div className="org-row org-row-top">
                      <div className="org-node org-node-chairman">이사장</div>
                    </div>

                    {/* MID – 감사 / 원장 · 사무국장 / 위원회 */}
                    <div className="org-row org-row-mid">
                      {/* 가운데 horizontal line */}
                      <div className="org-mid-line" />

                      <div className="org-mid-col org-mid-left">
                        <div className="org-node org-node-side">감사</div>
                      </div>

                      <div className="org-mid-col org-mid-center">
                        <div className="org-node org-node-middle">원장</div>
                        <div className="org-node org-node-middle">사무국장</div>
                      </div>

                      <div className="org-mid-col org-mid-right">
                        <div className="org-committee-box">
                          <div className="org-committee-inner">
                            <div className="org-node-committee">운영위원회</div>
                            <div className="org-node-committee">자문위원회</div>
                            <div className="org-node-committee">투심위원회</div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* BOTTOM – 경영기획실 / 기업지원실 / 창업육성실 */}
                    <div className="org-row org-row-bottom">
                      {/* 아래쪽 horizontal line */}
                      <div className="org-bottom-line" />

                      {/* 경영기획실 */}
                      <div className="org-bottom-card">
                        <div className="org-bottom-header">
                          <h4 className="org-bottom-title">경영기획실</h4>
                          <p className="org-bottom-sub">행정지원팀 | 산학기획팀 | 교육지원센터</p>
                        </div>
                        <div className="org-bottom-body">
                          <p>· 인사, 회계, 법인 행정</p>
                          <p>· 대외 협력 업무 및 홍보</p>
                          <p>· 기업연구동 관리</p>
                          <p>· 입주기업 운영 및 유치</p>
                          <p>· 신규사업 기획 발굴 및 기획</p>
                          <p>· 충남지역혁신클러스터(기업유치)</p>
                          <p>· 탄소중립실증인프라구축사업</p>
                          <p>
                            · 산학협력인력양성프로그램
                            <br />
                            &nbsp;&nbsp;(충남도 교육청)
                          </p>
                        </div>
                      </div>

                      {/* 기업지원실 */}
                      <div className="org-bottom-card">
                        <div className="org-bottom-header">
                          <h4 className="org-bottom-title">기업지원실</h4>
                          <p className="org-bottom-sub">인재양성팀 | 기업지원팀 | 아산시센터</p>
                        </div>
                        <div className="org-bottom-body">
                          <p>
                            · 산학융합지구조성사업
                            <br />
                            &nbsp;&nbsp;(기업밀착형 산학융합촉진지원)
                          </p>
                          <p>
                            · 지역산업맞춤형인력양성사업
                            <br />
                            &nbsp;&nbsp;(공동훈련센터)
                          </p>
                          <p>· 충남지역혁신클러스터(인력양성)</p>
                          <p>· 에너지 동반성장 상생협력지원사업</p>
                          <p>· 지역주도형 청년일자리사업</p>
                          <p>· 한국형 퀵스타트사업</p>
                          <p>· 청년일자리도약장려금사업</p>
                          <p>· 지역혁신프로젝트</p>
                          <p>
                            · 미래내일일경험사업
                            <br />
                            &nbsp;&nbsp;(직무교육기관/인턴형)
                          </p>
                        </div>
                      </div>

                      {/* 창업육성실 */}
                      <div className="org-bottom-card">
                        <div className="org-bottom-header">
                          <h4 className="org-bottom-title">창업육성실</h4>
                          <p className="org-bottom-sub">미래기술팀 | 혁신창업팀 | 홍성센터</p>
                        </div>
                        <div className="org-bottom-body">
                          <p>· 중장년기술창업센터사업</p>
                          <p>· 청년취창업활성화지원사업</p>
                          <p>· 청년성장프로젝트사업</p>
                          <p>· 청년도전지원사업</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* ───────── 조직도 영역 끝 ───────── */}

              {/* ───────── 직원정보 리스트 영역 ───────── */}
              <div className="board_wrap organization-board">
                <div className="board_back">
                  <div className="board_container vision">
                    <div className="vision_title_box">
                      <div className="logo_box">
                        <div className="logo_img"></div>
                      </div>
                      <div className="title_text">조직별 업무 및 담당 안내</div>
                    </div>

                    <div className="org-subtab">
                      <div className="org-subtab__title">{getCategoryName(category)}</div>

                      <div className="org-subtab__tabs">
                        <div
                          className={`org-subtab__tab ${tab === 'management' ? 'is-active' : ''}`}
                          onClick={() => handleTab('management')}
                        >
                          경영기획실
                        </div>
                        <div
                          className={`org-subtab__tab ${tab === 'enterprise' ? 'is-active' : ''}`}
                          onClick={() => handleTab('enterprise')}
                        >
                          기업지원실
                        </div>
                        <div
                          className={`org-subtab__tab ${tab === 'founded' ? 'is-active' : ''}`}
                          onClick={() => handleTab('founded')}
                        >
                          창업육성실
                        </div>
                      </div>
                    </div>

                    <div className="list_area">
                      <div className="write_box">
                        {s1 === 'admin' && (
                          <div className="write_btn" onClick={infoWrite}>
                            {getCategoryName(category)} 직원정보 등록
                          </div>
                        )}
                      </div>

                      <div className="org-staff-table-wrapper">
                        <table className="org-staff-table">
                          <thead className="org-staff-table__head">
                            <tr className="org-staff-table__head-row">
                              <th className="org-staff-table__head-cell org-staff-table__head-cell--team">팀</th>
                              <th className="org-staff-table__head-cell org-staff-table__head-cell--spot">직위</th>
                              {/* <th className="org-staff-table__head-cell">이름</th> */}
                              <th className="org-staff-table__head-cell org-staff-table__head-cell--tel">전화번호</th>
                              <th className="org-staff-table__head-cell org-staff-table__head-cell--email">이메일</th>
                              <th className="org-staff-table__head-cell org-staff-table__head-cell--work">업무</th>
                            </tr>
                          </thead>

                          <tbody className="org-staff-table__body">
                            {boardData.length === 0 ? (
                              <tr className="org-staff-table__body-row">
                                <td className="org-staff-table__no-data" colSpan="5">
                                  데이터가 존재하지 않습니다.
                                </td>
                              </tr>
                            ) : (
                              boardData.map((data, index) => {
                                const prevTeam = index > 0 ? boardData[index - 1].team : null;

                                let rowSpan = 1;
                                if (data.team !== prevTeam) {
                                  for (let i = index + 1; i < boardData.length; i++) {
                                    if (boardData[i].team === data.team) rowSpan++;
                                    else break;
                                  }
                                }

                                const showTeamCell = data.team !== prevTeam;

                                return (
                                  <tr className="org-staff-table__body-row" key={index}>
                                    {showTeamCell && (
                                      <td
                                        className="org-staff-table__body-cell org-staff-table__body-cell--team"
                                        rowSpan={rowSpan}
                                      >
                                        {data.team}
                                      </td>
                                    )}
                                    <td className="org-staff-table__body-cell org-staff-table__body-cell--spot">
                                      {data.spot}
                                    </td>
                                    <td className="org-staff-table__body-cell org-staff-table__body-cell--tel">
                                      {data.tel}
                                    </td>
                                    <td className="org-staff-table__body-cell org-staff-table__body-cell--email">
                                      {data.email}
                                    </td>
                                    <td className="org-staff-table__body-cell org-staff-table__body-cell--work">
                                      {renderWorkLines(data.work)}
                                    </td>
                                  </tr>
                                );
                              })
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* ───────── 직원정보 리스트 영역 끝 ───────── */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Organization;
